import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import './CheckInSheet.scss';

import CheckIcon from 'icons/CheckIcon';
import { getRealAge} from 'util/lifterHelper';
import { getSessionOptions } from 'util/options';
import { getCurrentMeet } from 'selectors';

class CheckInSheet extends Component {

  render() {
    const { meet } = this.props;

    const lifters = _.sortBy(meet.lifters, ['name']);
    const meetItems = meet.entryConfig.items;

    return (
      <div className="check-in-sheet">
        {
          _.map(getSessionOptions(), (session) => {
            const sessionLifters = _.filter(lifters, {session: session.value});
            const sessionCount = _.size(sessionLifters);
            if(!sessionCount) {
              return null;
            }

            return (
              <div key={session.value} className="session-pages">
                <div className="meet-name">{meet.date} - {meet.name} - Session {session.value} - CHECK IN</div>
                <table>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Member Number</th>
                      <th>Current Member <CheckIcon/></th>
                      <th>Photo ID <CheckIcon/></th>
                      <th>State</th>
                      <th>Birth Date</th>
                      <th>Age</th>
                      <th>Liability <CheckIcon/></th>
                      <th>T-shirt</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      _.map(sessionLifters, (lifter) => {
                        return (
                          <tr key={lifter._id}>
                            <td>{lifter.name}</td>
                            <td>{lifter.restricted.memberNumber}</td>
                            <td></td>
                            <td></td>
                            <td>{lifter.state}</td>
                            <td>{lifter.birthDate}</td>
                            <td>{getRealAge(lifter, meet)}</td>
                            <td></td>
                            <td>
                              {
                                _.map(lifter.restricted.items, (itemId, index) => {
                                  const item = _.find(meetItems, {id: itemId});
                                  return (
                                    <span key={index}>
                                      {_.get(item, 'name')}{_.size(lifter.restricted.items) !== index+1 && ', '}
                                    </span>
                                  );
                                })
                              }
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              </div>
            );
          })
        }
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(CheckInSheet);
